module.exports = __webpack_public_path__ + "img/noAmazon_icon.f13e5bbe.png";